<template>
  <div id="usageStatusChart"></div>
</template>

<script>
  import c3 from 'c3'

  export default {
    name: 'usage-status-chart',
    props: {
      chartData: {
        type: Object,
        default () {
          return {}
        }
      },
      dateType: {
        type: String,
        default () {
          return 'day'
        }
      }
    },
    watch: {
      dateType (type) {
        const chartData = this.chartData[type]

        // x축 라벨 수정
        window.usageStatusChart.axis.labels({x: type === 'month' ? '(년/월)' : '(월/일)'})

        // 데이터가 변경되면 차트를 업데이트 한다.
        window.usageStatusChart.load({
          json: [ ...chartData ],
          keys: {
            x: 'period',
            value: [ 'total', 'active', 'new', 'ga_users' ]
          }
        })
      }
    },
    mounted () {
      // '일', '주', '월' 타입에 따라 x축 tick을 커스텀하여 반환한다.
      const customTick = (i) => {
        const type = this.dateType
        const chartData = this.chartData[type][i]
        const period = chartData.period.replace(' - ', '.').split('.')
        const tickOptions = {
          day: `${period[1]}/${period[2]} (${period[3]})`,
          week: `${period[1]}/${period[2]}`,
          month: `${period[0]}/${period[1]}`
        }

        return tickOptions[type]
      }

      // '일', '주', '월' 타입에 따라 tooltip을 커스텀하여 반환한다.
      const customTooltip = (i) => {
        const type = this.dateType
        const chartData = this.chartData[type][i]
        const period = chartData.period.replace(' - ', '.').split('.')
        const tooltipOptions = {
          day: `${period[0]}년 ${period[1]}월 ${period[2]}일 (${period[3]})`,
          week: `${period[0]}년 ${period[1]}월 ${period[2]}일 - ${period[4]}월 ${period[5]}일`,
          month: `${period[0]}년 ${period[1]}월`
        }

        return tooltipOptions[type]
      }

      // Chart config
      const config = {
        bindto: '#usageStatusChart',
        axis: {
          x: {
            type: 'category',
            label: {
              text: '(월/일)',
              position: 'inner-top'
            },
            tick: {
              culling: {
                max: 12
              },
              fit: true,
              centered: true,
              multiline: false,
              format: function (i) {
                return customTick(i)
              }
            }
          }
        },
        data: {
          json: [ ...this.chartData[this.dateType] ],
          keys: {
            x: 'period',
            value: [ 'total', 'active', 'new', 'ga_users' ]
          },
          colors: {
            total: '#ffd43b',
            active: '#9b88e9',
            new: '#ff7133',
            ga_users: '#8ebafb'
          },
          types: {
            total: 'area',
            active: 'area',
            new: 'area',
            ga_users: 'area'
          },
          names: {
            total: '전체 회원사',
            active: '사용 회원사',
            new: '신규 가입자',
            ga_users: 'GA 사용자'
          },
          order: null
        },
        grid: {
          y: {
            show: true
          }
        },
        point: {
          show: false
        },
        tooltip: {
          format: {
            title: function (i) {
              return customTooltip(i)
            }
          }
        },
        legend: {
          item: {
            tile: {
              width: 10,
              height: 10
            }
          },
          padding: 16
        }
      }

      // 컴포넌트 데이터에 차트 객체 복사 시 오류가 발생한다.
      // 대신 차트 객체를 Window 객체에 복사하여 사용한다.
      window.usageStatusChart = c3.generate(config)
    },
    beforeDestroy () {
      // 컴포넌트 초기화 시 Window 객체에 복사된 차트 객체를 제거한다.
      delete window.usageStatusChart
    }
  }
</script>

<style lang="scss">
  #usageStatusChart {
    .c3-axis-y path {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/UsageStatusChart.vue